
export const getEnvVariables = () => process.env;

